module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b63266e50eebc5ce414d484d2f7cc70c.png";